import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatDuration } from './utils';

export interface DurationBarProps {
  ms: number;
  maxMs: number;
  color?: string;
}

const DurationBar: React.FC<DurationBarProps> = ({ ms, maxMs, color = 'text.disabled' }) => {
  const pct = maxMs > 0 ? Math.max((ms / maxMs) * 100, 3) : 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
      <Box sx={{ flex: 1, height: 4, bgcolor: 'action.disabledBackground', borderRadius: 1, overflow: 'hidden' }}>
        <Box
          sx={{
            width: `${pct}%`,
            height: '100%',
            bgcolor: color,
            borderRadius: 1,
            transition: 'width 0.3s ease',
          }}
        />
      </Box>
      <Typography
        variant="caption"
        sx={{ fontFamily: 'monospace', minWidth: 40, textAlign: 'right', color: 'text.secondary' }}
      >
        {formatDuration(ms)}
      </Typography>
    </Box>
  );
};

export default DurationBar;
